import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AppConfiguration } from 'src/app/app.configuration';
import { EntradasService } from '../../venta/services/entradas.service';

export interface ValidacionAmigoDatos {
  nombreCompleto: string;
  tipoTarjeta: string;
  tipoColaborador: string;
  namigo: string;
  iCodigoClienteVinculado: string;
  categorias?: any[];
  tarifas?: any[];
}

export interface ValidacionAmigoResponse {
  datosResult: ValidacionAmigoDatos;
  mensajes: any[];
  categorias?: any[];
  tarifas?: any[];
}

export interface AmigoActivo {
  namigo: string;
  iCodigoClienteVinculado: string;
}

@Injectable()
export class AmigosThyssenService {
  private amigoActivo?: AmigoActivo;

  constructor(
    private http: HttpClient,
    private config: AppConfiguration,
    private entradasService: EntradasService
  ) {}

  validarAmigo(numero: string, dni: string): Observable<ValidacionAmigoResponse> {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
   
    const params = new HttpParams()
      .set('ConexionId', conexionId)
      .set('namigo', numero)
      .set('id', dni);
  
    return this.http.get<ValidacionAmigoResponse>(
      `${this.config.getConfig('API_URL_MS')}/api/Externos/ValidarAmigosThyssen`,
      { params }
    );
  }
  

  setAmigoActivo(amigo?: AmigoActivo): void {
    if (!amigo) {
      this.amigoActivo = undefined;
      return;
    }
    this.amigoActivo = amigo;
  }

  getAmigoActivo(): AmigoActivo | undefined {
    // console.log('👤 [AMIGOS THYSSEN SERVICE] getAmigoActivo() - amigoActivo:', this.amigoActivo);
    return this.amigoActivo;
  }

  clearAmigoActivo(): void {
    this.amigoActivo = undefined;
  }

  cargarCategoriasYTarifas(codigoCliente: string, categoriaId?: string): Observable<{categorias: any[], tarifas: any[]}> {
    /* console.log('📋 [AMIGOS THYSSEN SERVICE] cargarCategoriasYTarifas() - INICIO');
    console.log('📋 [AMIGOS THYSSEN SERVICE] codigoCliente:', codigoCliente);
    console.log('📋 [AMIGOS THYSSEN SERVICE] categoriaId opcional:', categoriaId); */
    
    return new Observable(observer => {
      // Cargar categorías con los parámetros específicos de la US
      this.getCategoriasAmigosThyssen(codigoCliente).subscribe(categorias => {
        console.log('📋 [AMIGOS THYSSEN SERVICE] Categorías cargadas:', categorias);
        // Cargar tarifas con los parámetros específicos de la US
        this.getTarifasAmigosThyssen(codigoCliente, categoriaId).subscribe(tarifas => {
          console.log('📋 [AMIGOS THYSSEN SERVICE] Tarifas cargadas:', tarifas);
          observer.next({ categorias, tarifas });
          observer.complete();
        }, error => {
          console.error('❌ [AMIGOS THYSSEN SERVICE] Error al cargar tarifas en cargarCategoriasYTarifas:', error);
          observer.error(error);
        });
      }, error => {
        console.error('❌ [AMIGOS THYSSEN SERVICE] Error al cargar categorías en cargarCategoriasYTarifas:', error);
        observer.error(error);
      });
    });
  }

  // Método para cargar solo las tarifas de una categoría específica
  cargarTarifasPorCategoria(codigoCliente: string, categoriaId: string): Observable<any[]> {
    console.log('🔧 [AMIGOS THYSSEN SERVICE] cargarTarifasPorCategoria() - INICIO');
    console.log('🔧 [AMIGOS THYSSEN SERVICE] codigoCliente:', codigoCliente);
    console.log('🔧 [AMIGOS THYSSEN SERVICE] categoriaId:', categoriaId);
    return this.getTarifasAmigosThyssen(codigoCliente, categoriaId);
  }

  // Método específico para GetKoreCategorias con parámetros de Amigos Thyssen
  private getCategoriasAmigosThyssen(codigoCliente: string): Observable<any[]> {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      TPVId: '0', // Según la US
      CodigoCliente: codigoCliente,
      FiltrarPorCliente: '1', // Según la US
      Fecha: ''
    };

    return this.http.post(`${this.config.getConfig('API_URL')}api/GetKoreCategorias`, body)
      .pipe(
        map((res: any) => {
          if (!res.DatosResult) {
            return [];
          }
          return res.DatosResult.ListadoCategoriasDisponibles;
        })
      );
  }

  // Método específico para GetKoreTarifasDisponibles con parámetros de Amigos Thyssen
  private getTarifasAmigosThyssen(codigoCliente: string, categoriaId?: string): Observable<any[]> {
    /* console.log('🌐 [AMIGOS THYSSEN SERVICE] getTarifasAmigosThyssen() - INICIO');
    console.log('🌐 [AMIGOS THYSSEN SERVICE] codigoCliente:', codigoCliente);
    console.log('🌐 [AMIGOS THYSSEN SERVICE] categoriaId recibido:', categoriaId); */
    
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const categoriaIdFinal = categoriaId ? parseInt(categoriaId) : 0;
    
    console.log('🌐 [AMIGOS THYSSEN SERVICE] categoriaId final (parseado):', categoriaIdFinal);
    
    const body = {
      ConexionIacpos: conexionId,
      TPVId: '0', // Según la US
      CodigoCliente: codigoCliente,
      FiltrarPorCliente: '1', // Según la US
      CategoriaId: categoriaIdFinal, // Usar la categoría seleccionada o 0 para todas
      Fecha: ''
    };

    console.log('🌐 [AMIGOS THYSSEN SERVICE] Body enviado al API:', body);
    console.log('🌐 [AMIGOS THYSSEN SERVICE] URL del API:', `${this.config.getConfig('API_URL')}api/GetKoreTarifasDisponibles`);

    return this.http.post(`${this.config.getConfig('API_URL')}api/GetKoreTarifasDisponibles`, body)
      .pipe(
        map((res: any) => {
          console.log('📡 [AMIGOS THYSSEN SERVICE] Respuesta del API GetKoreTarifasDisponibles:', res);
          if (!res.DatosResult) {
            console.log('⚠️ [AMIGOS THYSSEN SERVICE] No hay DatosResult en la respuesta');
            return [];
          }
          console.log('✅ [AMIGOS THYSSEN SERVICE] Tarifas encontradas:', res.DatosResult.ListadoKoreTarifasDisponibles?.length || 0);
          return res.DatosResult.ListadoKoreTarifasDisponibles;
        }),
        catchError((error) => {
          console.error('❌ [AMIGOS THYSSEN SERVICE] Error en getTarifasAmigosThyssen:', error);
          return of([]);
        })
      );
  }
}
